import { atom } from "recoil";


const SideMenuAtom = atom({
    default: false,
    key: 'sideMenuAtom'
})

export default SideMenuAtom;